import {FormattedMessage, IntlShape} from 'react-intl';
import {Construction} from '.cache/__types__';

export const translations = {
    [Construction.Drevostavba]: <FormattedMessage defaultMessage="Dřevostavba" />,
    [Construction.Cihla]: <FormattedMessage defaultMessage="Cihla" />,
    [Construction.Panel]: <FormattedMessage defaultMessage="Panel" />,
    [Construction.Nizkoenergeticky]: <FormattedMessage defaultMessage="Nízkoenergetický" />,
    [Construction.Undefined]: <FormattedMessage defaultMessage="Neurčeno" />,
    [Construction.Ostatni]: <FormattedMessage defaultMessage="Ostatní" />,
};

export const translationsString = {
    [Construction.Drevostavba]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Dřevostavba'}),
    [Construction.Cihla]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Cihla'}),
    [Construction.Panel]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Panel'}),
    [Construction.Nizkoenergeticky]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Nízkoenergetický'}),
    [Construction.Undefined]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Neurčeno'}),
    [Construction.Ostatni]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Ostatní'}),
};

export const getTranslationString = (intl: IntlShape, key: Construction) => translationsString[key](intl);

export const label = <FormattedMessage defaultMessage="Typ budovy" />;
